import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import { Button } from 'reactstrap';
import { titleize } from 'lib/support';

export default class FieldsArray extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired,
    componentProps: PropTypes.object,
    resourceName: PropTypes.string,
    btnVisibleAfterFilling: PropTypes.bool,
    additionalAction: PropTypes.node,
    additionalActionClassName: PropTypes.node,
    additionalActionVisibleWithButton: PropTypes.bool,
    btnVisible: PropTypes.bool,
    max: PropTypes.number,
    formErrors: PropTypes.object,
    rerenderOnEveryChange: PropTypes.bool,
  };

  static defaultProps = {
    componentProps: {},
    resourceName: '',
    btnVisibleAfterFilling: false,
    btnVisible: true,
    max: 100,
    additionalAction: null,
    rerenderOnEveryChange: false,
    additionalActionClassName: 'col',
    additionalActionVisibleWithButton: false
  }

  renderFields = ({ fields }) => {
    const Component = this.props.component;

    let btnVisible = this.props.btnVisible;
    let additionalVisible = true;
    if (fields.length >= this.props.max) {
      btnVisible = false;
    }
    if (this.props.btnVisibleAfterFilling &&
      fields.length > 0 &&
      Object.keys(fields.get(fields.length - 1)).length === 0
    ) {
      btnVisible = false;
    }
    if (this.props.additionalActionVisibleWithButton) {
      additionalVisible = btnVisible;
    }

    return (
      <div className="mb-3 condensed-form-group">
        {fields.map((member, index, fields) => <Component
          key={`${this.props.name}-fae-${index}`}
          member={member}
          formErrors={this.props.formErrors}
          index={index}
          fields={fields}
          currencies={this.props.currencies}
          {...this.props.componentProps}
        />)}
        <div className="row align-items-center">
          <div className="col">
            {btnVisible && <Button color="info" onClick={() => fields.push({})}>
              + Add {titleize(this.props.resourceName)}
            </Button>}
          </div>
          {additionalVisible && <div className={`text-right ${this.props.additionalActionClassName}`}>
            {this.props.additionalAction}
          </div>}
        </div>
      </div>
    );
  }

  render() {
    return (
      <FieldArray
        name={this.props.name}
        component={this.renderFields}
        rerenderOnEveryChange={this.props.rerenderOnEveryChange}
      />
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/FieldsArray.jsx